<template>
    <div>
        <v-container class="d-print-none">
            <v-row no-gutters>
                <v-col :cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        <router-link
                            class="link-a"
                            :to="{
                                path: '/Inventory/Stock/' + pages,
                                query: { q: form_query },
                            }"
                            >STOCK</router-link
                        >
                        / STOCK IN - BARCODE
                    </h1>
                </v-col>
                <v-col :cols="6" class="text-right">
                    <v-btn
                        color="teal"
                        dark
                        class="mb-2"
                        rounded
                        @click="print()"
                        small
                        v-if="checkbox != ''"
                    >
                        <v-icon small class="mr-1">mdi-printer</v-icon> Print
                        Barcode</v-btn
                    ></v-col
                >
            </v-row>
            <v-card>
                <v-list three-line subheader>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title>
                                <b
                                    >LIST ALL PART BARCODE - PART NAME :
                                    {{ part.part_name }}</b
                                >
                                <v-spacer></v-spacer>
                            </v-list-item-title>
                            <!-- <v-list-item-subtitle></v-list-item-subtitle> -->
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                <template>
                    <v-card flat class="">
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Single Part
                                                        </th>
                                                        <th class="text-center">
                                                            Serial
                                                        </th>
                                                        <th class="text-center">
                                                            Stockin Date
                                                        </th>
                                                        <th>
                                                            <v-btn
                                                                small
                                                                :color="colorx"
                                                                @click="all()"
                                                                rounded
                                                                >All</v-btn
                                                            >
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr
                                                        v-for="(item,
                                                        index) in part.onhand"
                                                        :key="item.singlepart"
                                                    >
                                                        <td class="text-center">
                                                            {{ index + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                item.singlepart
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{ item.serial }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                item.created_date
                                                            }}
                                                        </td>
                                                        <td>
                                                            <v-checkbox
                                                                v-model="
                                                                    checkbox
                                                                "
                                                                label=""
                                                                :value="item"
                                                                color="green"
                                                            ></v-checkbox>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </template>
            </v-card>
        </v-container>
        <div id="printDiv">
            <div
                v-for="(data_barcode, index) in checkbox"
                :key="data_barcode.singlepart"
                class="cols"
            >
                <table
                    width="100%"
                    border="0"
                    cellspacing="0"
                    cellpadding="0"
                    style="padding: 0px !important;
                            border-width: 1px;
                            border-left-style: dashed;
                            border-bottom-style: dashed;
                            border-right-style: dashed;
                            border-top-style: dashed;"
                >
                    <tr>
                        <td width="36%" align="center">
                            <img
                                src="../../assets/bardode/acacia.jpg"
                                class="img-1"
                                style="margin-top:10px; margin-bottom: 10px;"
                            />
                        </td>
                        <td width="64%" align="left" colspan="2">
                            <b>{{
                                part.project_name +
                                    " - " +
                                    part.part_description
                            }}</b>
                            <br />
                            <span>
                                SN : <b>{{ data_barcode.serial }}</b>
                            </span>
                        </td>
                    </tr>
                    <!-- <tr> -->
                    <!-- <td align="center">
                            Serial Part :
                        </td>
                        <td width="80%" colspan="2">
                            <b>{{ data_barcode.serial }}</b>
                            <br />
                        </td> -->
                    <!-- <td width="60%" align="center">
                            <barcode
                                v-bind:value="data_barcode.serial"
                                width="1"
                                height="50"
                                font-size="12"
                            >
                            </barcode>
                        </td>
                        <td>
                            <qr-code
                                :text="data_barcode.serial"
                                size="50"
                                style="margin-right:15px;"
                            ></qr-code>
                        </td> -->
                    <!-- </tr> -->
                    <tr>
                        <td align="center">
                            Single Part :
                        </td>
                        <td width="48%" align="center">
                            <!-- :class="index === 84 || index === 85? 'bar-1 mar-2': 'bar-1'" -->
                            <barcode
                                v-bind:value="data_barcode.singlepart"
                                width="1"
                                height="85"
                                font-size="12"
                            >
                            </barcode>
                        </td>
                        <td width="48%">
                            <qr-code
                                :text="data_barcode.singlepart"
                                :size="85"
                                style="margin-right:15px;"
                            ></qr-code>
                        </td>
                    </tr>
                </table>

                <div
                    :class="
                        index + 1 != 1 && (index + 1) % 14 === 0
                            ? 'break-after'
                            : ''
                    "
                ></div>
            </div>
            <!-- <div class="break-after">1</div>
            <div class="break-before">2</div>
            <div class="break-before">3</div> -->
        </div>
    </div>
</template>
<script>
const url = `${process.env.VUE_APP_ROOT_API}/api/getbarcode/`

import axios from "axios"
import VueBarcode from "vue-barcode"

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_barcode()
        this.pages = this.$route.params.pages
        this.form_query = this.$route.query.q
    },
    components: {
        barcode: VueBarcode,
    },
    methods: {
        async get_barcode() {
            let { data } = await axios.get(url + this.$route.params.id, this.tk)
            this.part = data[0]
        },
        all() {
            if (this.chk === true) {
                this.chk = false
                this.colorx = "primary"
                this.checkbox = []
            } else {
                this.chk = true
                this.colorx = "success"
                this.checkbox = this.part.onhand
            }
        },
        print() {
            // window.print()
            // this.$htmlToPaper("printDiv")
            const localOptions = {
                styles: [
                    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    "https://aitt.netlify.app/barcode.css",
                ],
            }

            this.$htmlToPaper("printDiv", localOptions, () => {
                // console.log(localOptions)
                // console.warn("done landscape")
            })
        },
    },
    data() {
        return {
            checkbox: [],
            qrCls: "qrcode",
            size: 45,
            // size: 56,
            background: "#FFFF",
            chk: false,
            colorx: "primary",
            output: null,
            part: [],
            pages: 0,
            form_query: null,
            tk: null,
        }
    },
}
</script>
<style scoped>
/* .break-after {
    display: block;
    page-break-after: always;
    page-break-inside: avoid;
    position: relative;
}

.break-before {
    display: block;
    page-break-before: always;
    position: relative;
} */

.cols {
    padding: 0px;
    float: left;
    width: 49%;
}

#printDiv {
    display: none;
}
th {
    font-size: 16px !important;
}
.pad-0 {
    padding: -10px !important;
}
.mar-1 {
    margin-left: 14px !important;
}
.mar-2 {
    margin-top: -25px !important;
}
.mar-3 {
    margin-top: -65px !important;
}
.mar-4 {
    margin-top: -35px !important;
}
.vue-barcode-element {
    width: 45%;
    height: 50px;
}

.img-1 {
    width: 35% !important;
}

.mar-a {
    /* display: none; */
    margin-left: 0px;
    margin-top: 0px;
}

@media print {
    .mar-a {
        margin-left: -290px !important;
        margin-top: -75px !important;
    }
}
</style>
